import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProjectAdminSubContainerStyled } from '../../styled';
import { UserItemList } from './list';
import { UserDetail } from './detail';
import { CreateUser } from './create';
import { ErrorBoundary, NotFound } from '@bechtel/client-common';

export const ManageUsers = () => {
  return (
    <ProjectAdminSubContainerStyled style={{ overflowY: 'hidden' }}>
      <ErrorBoundary>
        <UserItemList />
      </ErrorBoundary>
      <ErrorBoundary>
        <Routes>
          <Route path={`/:id`} element={<UserDetail />} />
          <Route path="/" element={<UserDetail />} />
          <Route path={`/user/create`} element={<CreateUser />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </ProjectAdminSubContainerStyled>
  );
};

export default ManageUsers;
